import { RoleDto } from './role.dto';

export class Role {
    id: string;
    code: string;
    displayName: string;
    description: string;
    isSystem: boolean;
    permissionCodes: string[];

    constructor(data: RoleDto) {
        this.id = data.id;
        this.code = data.code;
        this.displayName = data.displayName;
        this.description = data.description ?? '';
        this.isSystem = data.isSystem;
        this.permissionCodes = data.permissionCodes ?? [];
    }
}
